import React, { useEffect } from "react";
import ReactMarkdown from "react-markdown";

import remarkGfm from "remark-gfm";
import remarkMath from "remark-math";
import rehypeHighlight from "rehype-highlight";
import rehypeKatex from "rehype-katex";

import mermaid from "mermaid";

// highlight.js CSS
import "highlight.js/styles/github.css";

// KaTeX CSS
import "katex/dist/katex.min.css";

export default function MarkdownRenderer({ content }) {

    //
    // === MERMAID � pe�ne wsparcie dla WSZYSTKICH diagram�w ===
    //
    useEffect(() => {
        mermaid.initialize({
            startOnLoad: false,
            theme: "default",
            securityLevel: "loose", // pozwala na wszystko
        });

        const mermaidBlocks = document.querySelectorAll("pre code.language-mermaid");

        mermaidBlocks.forEach((codeBlock) => {
            const code = codeBlock.textContent.trim();

            if (!code || code.length < 3) return;

            const container = document.createElement("div");
            container.className = "mermaid";
            container.textContent = code;

            const pre = codeBlock.closest("pre");
            if (!pre) return;

            pre.replaceWith(container);

            // render + responsywno�� SVG
            mermaid.run().then(() => {
                const svg = container.querySelector("svg");
                if (!svg) return;

                let rawWidth = svg.getAttribute("width");
                let rawHeight = svg.getAttribute("height");

                const width =
                    rawWidth && rawWidth.endsWith("%")
                        ? null
                        : parseFloat(rawWidth) || null;

                const height =
                    rawHeight && rawHeight.endsWith("%")
                        ? null
                        : parseFloat(rawHeight) || null;

                const box = svg.getBBox();

                const finalW = width || box.width || 500;
                const finalH = height || box.height || 200;

                svg.removeAttribute("width");
                svg.removeAttribute("height");

                svg.setAttribute("viewBox", `0 0 ${finalW} ${finalH}`);
                svg.setAttribute("preserveAspectRatio", "xMinYMin meet");

                svg.style.width = "100%";
                svg.style.height = "auto";
            });
        });
    }, [content]);


    //
    // === COPY BUTTONS � bez zmian, twoje dzia�a idealnie ===
    //
    useEffect(() => {
        document.querySelectorAll("pre code").forEach((codeBlock) => {
            const pre = codeBlock.parentElement;

            if (codeBlock.classList.contains("language-mermaid")) return;
            if (pre.querySelector(".copy-btn")) return;

            const classList = [...codeBlock.classList];

            const isActualCode =
                classList.includes("hljs") &&
                classList.some(
                    (c) =>
                        c.startsWith("language-") &&
                        ![
                            "language-markdown",
                            "language-text",
                            "language-plaintext",
                            "language-mermaid",
                        ].includes(c)
                );

            if (!isActualCode) return;

            const btn = document.createElement("button");
            btn.className =
                "copy-btn absolute top-2 right-2 px-2 py-1 text-xs bg-gray-800 text-white hover:bg-gray-700 rounded";
            btn.textContent = "Copy";

            btn.onclick = () => {
                const codeEl = btn.closest("pre").querySelector("code");
                if (!codeEl) return;

                const raw = codeEl.textContent;
                navigator.clipboard.writeText(raw);

                btn.textContent = "Copied!";
                setTimeout(() => (btn.textContent = "Copy"), 1200);
            };

            pre.style.position = "relative";
            pre.appendChild(btn);
        });
    }, [content]);


    //
    // === FINAL RENDER (dodane KaTeX + Math) ===
    //
    return (
        <div className="prose prose-sm max-w-full overflow-x-hidden">
            <ReactMarkdown
                remarkPlugins={[remarkGfm, remarkMath]}
                rehypePlugins={[rehypeHighlight, rehypeKatex]}
            >
                {content}
            </ReactMarkdown>
        </div>
    );
}
